import { AdresseGouv } from '@mairistem/adresses';
import { Combobox, Form, Input } from '@mairistem/composants';
import { ListeTable, OnKeyDownHandler } from '@mairistem/liste';
import _ from 'lodash';

const ListeTiersRow = (props) => {
  const { tiers, civilites, rowProps, utilities } = props;

  const handleChange = (e, data) => {
    const { name, value } = data;

    utilities?.onChange({ [name]: _.upperFirst(value) });
  };

  const handleAdresseChange = (adresse) => {
    utilities?.onChange({ adresse });
  };

  return (
    <ListeTable.Row key={tiers?.identifiant} {...rowProps}>
      <ListeTable.Cell name="civilite" stretched>
        {/* @ts-expect-error */}
        <Combobox
          name="civilite"
          selection
          style={{ minWidth: '100%' }}
          options={civilites}
          onChange={handleChange}
          value={tiers?.civilite}
          {...utilities?.disableFocus}
          {...utilities?.disableDrag}
          onKeyDown={utilities?.onKeyDown([
            OnKeyDownHandler.validateOnEnter,
            OnKeyDownHandler.disableShiftTabulation,
            OnKeyDownHandler.rollbackOnEsc,
          ])}
        />
      </ListeTable.Cell>
      <ListeTable.Cell name="nom" stretched>
        <Input
          id={`nom-${tiers.identifiant}`}
          name="nom"
          placeholder="Nom"
          fluid
          transparent
          value={tiers.nom}
          onChange={handleChange}
          autoFocus={utilities?.autoFocus}
          onKeyDown={utilities?.onKeyDown([
            OnKeyDownHandler.validateOnEnter,
            OnKeyDownHandler.rollbackOnEsc,
          ])}
        />
      </ListeTable.Cell>
      <ListeTable.Cell name="prenom" stretched>
        <Input
          id={`prenom-${tiers.identifiant}`}
          name="prenom"
          placeholder="Prénom"
          onChange={handleChange}
          fluid
          transparent
          value={tiers.prenom}
          onKeyDown={utilities?.onKeyDown([
            OnKeyDownHandler.validateOnEnter,
            OnKeyDownHandler.rollbackOnEsc,
          ])}
        />
      </ListeTable.Cell>
      <ListeTable.Cell name="adresse" stretched>
        <Form className="modal-tiers-adresse">
          <AdresseGouv onAdresseChange={handleAdresseChange} adresse={tiers.adresse} />
        </Form>
      </ListeTable.Cell>
    </ListeTable.Row>
  );
};

export default ListeTiersRow;
